import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { QuoteButton } from "../components/CTAButtons";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found | My Mobile Mechanic" description="This page doesn't exist." path="/404" />
      <section className="mx-auto flex max-w-3xl flex-col items-center px-4 py-24 text-center sm:px-6">
        <p className="font-display text-8xl font-black text-crimson">404</p>
        <h1 className="mt-4 font-display text-3xl font-extrabold uppercase text-slate-50">
          This Page Rolled Out of the Shop
        </h1>
        <p className="mt-3 text-slate-400">The page you're looking for doesn't exist — but your brakes still might need us.</p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <QuoteButton />
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="inline-flex min-h-[52px] items-center justify-center border-2 border-edgehi px-7 font-display text-lg font-bold uppercase text-slate-100 transition-colors hover:border-amber2 hover:text-amber2"
          >
            Back Home
          </Link>
        </div>
      </section>
    </>
  );
}
